<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="">
            <div class="campus-intro">
              <div style="display: flex; font-size: 14px; line-height: 1.2">
                <img
                  src="https://res.cloudinary.com/orthodox-union/image/upload/v1605111734/brooklyn_college_logo_tv3l8z.jpg"
                  alt="Brooklyn College"
                  style="margin-right: 20px"
                />
                <p>
                  JLIC is partially funded by the generosity of the Orthodox Union and
                  Hillel. We also rely on your support. Your tax-deductible donation is a
                  great opportunity to help more young adults stay connected to their
                  Judaism at Brooklyn College. Through your partnership, we will continue
                  to expand and reach more Jewish students than ever before.
                </p>
              </div>
            </div>
          </FormSection>
          <FormSection title="Support Us">
            <AmountSelector />
            <ErrorLabel field="amount" />
            <FormRow inline>
              <FormCol field="designation" width="half">
              <FormSelect>
                <option value="Any Program">Any Program</option>
                <option value="Campus book Fund">Campus book Fund</option>
                <option value="Programming fund">Programming fund</option>
                <option value="Presence of OU-JLIC couple at a Campus">
                  Presence of OU-JLIC couple at a Campus
                </option>
                <option value="Shabbat Meals">Shabbat Meals</option>
                </FormSelect>
              </FormCol>
            </FormRow>
            <TransactionFee />
          </FormSection>
          <FormSection title="Donation Frequency">
            <DonationFrequency />
          </FormSection>
          <FormSection title="Your Details">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>             
            <FormRow>
              <FormLabel>
                <input type="checkbox" /> Would you like us to contact you regarding
                naming opportunities?
              </FormLabel>
            </FormRow>
            <br />
            <InHonorOf />
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
            <FormRow>
              <Receipt />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
</style>
